export default __webpack_public_path__ + "static/media/ic_arrow_right_white.20aa1c01.svg";